import { secureHttp } from '../secureHttp';
import type { Session } from '../../../types/session';
import { mapSessionResponse, RawSessionItem } from '../../../utils/sessionMapper';

export type SessionsTimeline = {
  upcoming: Session[];
  cancelled: Session[];
  settled: Session[];
};

function formatNowForApi(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  const yyyy = d.getFullYear();
  const mm = pad(d.getMonth() + 1);
  const dd = pad(d.getDate());
  const hh = pad(d.getHours());
  const mi = pad(d.getMinutes());
  const ss = pad(d.getSeconds());
  return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
}

interface SessionApiResponse {
  results: RawSessionItem[];
}

function mapSessionsData(resp: SessionApiResponse): Session[] {
  const items = Array.isArray(resp.results) ? resp.results : [];
  return items.map(mapSessionResponse);
}

export async function getPsychologistSessionsTimeline(opts?: { take?: number; from?: string; to?: string }): Promise<SessionsTimeline> {
  const now = formatNowForApi();
  const take = opts?.take ?? 100;

  const [upcomingResp, cancelledResp, settledResp] = await Promise.all([
    secureHttp.get<SessionApiResponse>(`/v1/psi-platform/psychologist/sessions`, { status: 'scheduled', from: opts?.from ?? now, take }),
    secureHttp.get<SessionApiResponse>(`/v1/psi-platform/psychologist/sessions`, { status: 'cancelled', take }),
    secureHttp.get<SessionApiResponse>(`/v1/psi-platform/psychologist/sessions`, { status: 'settled', to: opts?.to ?? now, take })
  ]);

  return {
    upcoming: mapSessionsData(upcomingResp),
    cancelled: mapSessionsData(cancelledResp),
    settled: mapSessionsData(settledResp)
  };
}


